<template>
  <div>
    <section class="info accordion">
      <div class="px-4">
        <table class="noselect w-100 table table-hover bg-white">
          <template v-for="(stats, client_id) in statsClient">
            <tbody
              :key="client_id + 2"
              :id="'collapseLocation' + client_id"
              class=""
              :aria-labelledby="'collapseLocation' + client_id"
              data-parent="#accordionlocation"
            >
              <tr
                :key="client_id + 'header'"
                class="font-weight-bold"
                v-if="statsDate.length > 1"
              >
                <td width="160px"></td>
                <td
                  width="120px"
                  v-for="date in statsDate"
                  :key="client_id + date.date"
                  class="text-right"
                >
                  <b>{{ date.date }}</b>
                </td>
                <td class="text-right" v-if="statsDate.length > 1">Total</td>
              </tr>
              <template v-if="!onlyTotal">
                <tr
                  v-for="statItem in statsType"
                  :key="statItem.id"
                  :set="(type = statItem.id)"
                >
                  <td>
                    <b>{{ type }}</b>
                  </td>

                  <td
                    v-for="date in statsDate"
                    :key="client_id + type + date.date"
                    class="text-right"
                  >
                    <span
                      v-if="
                        stats[date.date] != undefined &&
                        stats[date.date][type + '_' + statItem.format] !=
                          undefined
                      "
                    >
                      <span
                        class="small"
                        v-if="
                          statItem.showQty &&
                          stats[date.date] != undefined &&
                          stats[date.date][type] != undefined
                        "
                        >({{ stats[date.date][type] }})</span
                      >
                      {{
                        formatItem(
                          stats[date.date][type + "_" + statItem.format],
                          statItem
                        )
                      }}
                    </span>
                    <span v-else>-</span>
                  </td>
                  <td
                    class="text-right font-weight-bold"
                    v-if="statsDate.length > 1"
                  >
                    <span v-if="statItem.showTotal">
                      <span class="small" v-if="statItem.showQty"
                        >({{ stats[type] }})</span
                      >
                      {{
                        formatItem(
                          stats[type + "_" + statItem.format],
                          statItem
                        )
                      }}
                    </span>
                  </td>
                </tr>
              </template>
              <tr
                class="font-weight-bold"
                v-if="statsDate.length > 1 && showTotal"
              >
                <td>Total</td>

                <td
                  v-for="date in statsDate"
                  :key="client_id + date.date"
                  class="text-right"
                >
                  <span v-if="getTotal(date.date, stats)">
                    <span
                      class="small"
                      v-if="!onlyTotal && getTotalQty(date.date, stats)"
                      >({{ getTotalQty(date.date, stats) }})</span
                    >
                    {{ getTotal(date.date, stats) }}
                  </span>
                </td>
                <td class="text-right" v-if="false">
                  <span>
                    <span class="small" v-if="!onlyTotal"
                      >({{ getFullTotalQty(stats) }})</span
                    >
                    {{ getFullTotal(stats) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </template>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { statusBadgeMixin, urlMixin, logoMixin } from "@/_mixins/";
import { billingsService, clientsService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default {
  props: {
    // stats: {
    //   type: Object,
    //   required: true,
    // },
    statsClient: {
      type: Object,
      required: true,
    },
    statsType: {
      type: Array,
      required: true,
    },
    statsDate: {
      type: Array,
      required: true,
    },
    onlyTotal: {
      type: Boolean,
      onlyTotal: false,
    },
    showTotal: {
      type: Boolean,
      onlyTotal: true,
    },
  },
  data() {
    return {};
  },
  total: 0,
  totalQty: undefined,
  components: {
    LoadingSpinner,
  },
  computed: {
    created() {},
  },
  methods: {
    formatItem(amount, statItem) {
      switch (statItem.format) {
        case "amount":
          return parseFloat(amount).toFixed(2) + " €";
        case "percentage":
          return parseFloat(amount).toFixed(2) + " %";
        case "qty":
          return parseFloat(amount).toFixed(0);
      }
    },
    getTotal(date, stats) {
      let existData = false;
      let total = 0;
      this.statsType.forEach((statItem) => {
        let type = statItem.id;
        if (stats[date][type + "_" + statItem.format] != undefined) {
          total += parseFloat(stats[date][type + "_" + statItem.format]);
          existData = true;
        }
      });
      if (existData) {
        return parseFloat(total).toFixed(2);
      } else {
        return false;
      }
    },
    getTotalQty(date, stats) {
      let existData = false;
      let total = 0;
      this.statsType.forEach((statItem) => {
        let type = statItem.id;
        if (stats[date][type] != undefined) {
          total += parseFloat(stats[date][type]);
          existData = true;
        }
      });
      if (existData) {
        return parseFloat(total).toFixed(0);
      } else {
        return false;
      }
    },
    getFullTotal(stats) {
      let total = 0;
      this.statsType.forEach((statItem) => {
        let type = statItem.id;
        if (stats[type + "_" + statItem.format] != undefined) {
          total += parseFloat(stats[type + "_" + statItem.format]);
        }
      });
      return parseFloat(total).toFixed(2);
    },
    getFullTotalQty(stats) {
      let total = 0;
      this.statsType.forEach((statItem) => {
        let type = statItem.id;
        if (stats[type] != undefined) {
          total += parseFloat(stats[type]);
        }
      });
      return parseFloat(total).toFixed(0);
    },
  },
};
</script>
<style>
</style>